import useSwitchState from '@anm/hooks/useSwitchState';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { hostedVideoActions } from '../../../../store/modules/hostedVideo';

const useStreamModal = (hostId?: string) => {
  const dispatch = useDispatch();
  const [isStreamModalOpened, openStreamModal, closeStreamModal] = useSwitchState();

  useEffect(() => {
    if (!hostId || !isStreamModalOpened) return;

    dispatch(hostedVideoActions.getManifest(hostId));
  }, [hostId, isStreamModalOpened]);

  return [isStreamModalOpened, openStreamModal, closeStreamModal] as const;
};

export default useStreamModal;
